class CategoryTogglerView extends ViewBasic {
    constructor(options) {
        super(options);
    }

    init(){
        this.addEvents();
    }

    addEvents() {
        this.$('a').on('click', (e) => this.changeState(e));
    }

    removeEvents() {
        this.$('a').off('click', (e) => this.changeState(e));
    }

    changeState(e) {
        $(e.currentTarget).toggleClass('active');
        this.$('input').attr('checked', $(e.currentTarget).hasClass('active'));
    }
}

